// extracted by mini-css-extract-plugin
module.exports = {"normal":"Index_normal__2r6XI","animationFade":"Index_animationFade__XMzdd"};